import primaryButtonHover from '../../../../../common/algorithms/primary-button-hover';

const dark = (params) => primaryButtonHover(params);

export default dark;
